import { render, staticRenderFns } from "./RequisitionActivityDialog.vue?vue&type=template&id=5457e3ec&"
import script from "./RequisitionActivityDialog.vue?vue&type=script&lang=ts&"
export * from "./RequisitionActivityDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports